import { dev } from '$app/env';
import { wrap, type Remote } from 'comlink';

type Dictionary = typeof import('./dictionary-worker').Dictionary;

// TODO this is a bit clunky but addresses hot reloading for dev
export let dictionaryLoaded = $state<{ current?: Promise<number> }>(
  dev ? import.meta.hot?.data?.dictionaryLoaded ?? {} : {},
);

export let dictionary: Remote<Dictionary> | Dictionary =
  dev ? import.meta.hot?.data?.dictionary : {};

// Preserve initialized state across HMR so the while-loop in resetBoard
// doesn't hang waiting for a re-initialization that never happens.
if (import.meta.hot) {
  import.meta.hot.dispose((data) => {
    data.dictionaryLoaded = dictionaryLoaded;
    data.dictionary = dictionary;
  });
}

export const getDictionary = async () => {
  const { Dictionary } = await import('./dictionary-worker');
  dictionary = Dictionary;
  return dictionary;
};

export const getDictionaryWorker = () => {
  dictionary = wrap<Dictionary>(
    new Worker(new URL('./dictionary-worker', import.meta.url), {
      name: 'dictionary',
      type: 'module',
    }),
  );
  return dictionary;
};
